module.exports = __webpack_public_path__ + "img/pres_2.7a415609.jpg";